'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const clients = [
	'/services/client-sber.svg',
	'/services/client-centr-materialov.svg',
	'/services/client-pravitelstvo-moscow.svg',
	'/services/client-noviy-gorod.svg',
	'/services/client-pravitelstvo-io.svg',
	'/services/client-aeb.svg',
	'/services/client-partner.svg',
	'/services/client-aatz.svg',
	'/services/client-alfa.svg',
	'/services/client-izgt.svg',
	'/services/client-my-biznes.svg',
	'/services/client-gazobeton.svg'
]

const Clients: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
					Наши партнёры и клиенты
					</Typography>
					<Typography variant='h2' className={styles.title}>
					Нам доверяют
					</Typography>
				</div>
			</AnimatedSection>

			<AnimatedSection animation="slideUp">
			<div className={styles.logos}>
				{clients.map((logo, idx) => (
					<div key={idx} className={styles.logoContainer}>
						<img src={logo} alt={`Client ${idx + 1}`} className={styles.logo} />
					</div>
				))}
			</div>
			</AnimatedSection>
		</section>
	)
}

Clients.displayName = 'Clients'

export default Clients

